import React, { useContext, useEffect, useState } from "react";
import {
  Card,
  CardHeader,
  CardBody,
  Container,
  Row,
  Col,
  Label,
  Button,
  UncontrolledTooltip,
  Input,
} from "reactstrap";
import { useNavigate, useParams } from "react-router-dom";
import AdminHeader from "components/Headers/AdminHeader";
import {
  urlDecodedId,
  urlEncodedId,
} from "components/CommonComponents/encodeDecodeFunction";
import CommonTable from "components/CommonComponents/ReactTable/Table";
import { DEFAULT_RECORDS_PER_PAGE } from "components/constant";
import { getTraineeList, downloadTraineeQRCode } from "action/trainee";
import { useDispatch, useSelector } from "react-redux";
import { getChannelPartnerById } from "action/channelPartner";
import { traineeList } from "constants/trainee";
import { NotificationContext } from "components/CommonComponents/NotificationProvider";
import DetailsHeader from "components/CommonComponents/DetailsHeader";
import CommonModal from "components/CommonComponents/CommonModal";

const initialState = {
  organizationName: {
    value: "ABC Pvt Ltd",
    error: "",
  },
  //contact person first name + last name
  contactPersonName: {
    value: "John Doe",
    error: "",
  },
  firstName: {
    value: "",
    error: "",
  },
  lastName: {
    value: "",
    error: "",
  },
  email: {
    value: "johndoe@example.com",
    error: "",
  },
  mobileNumber: {
    value: "9876543210",
    error: "",
  },
  gstNumber: {
    value: "22AAAAA0000A1Z5",
    error: "",
  },
  registeredAddressLine1: {
    value: "123 Business Street",
    error: "",
  },
  registeredAddressLine2: {
    value: "Suite 101, Nashik, Maharashtra 422001",
    error: "",
  },
  landmark: {
    value: "Near City Centre Mall",
    error: "",
  },
  panNumber: {
    value: "AAACH2702H",
    error: "",
  },
  state: {
    value: "Maharashtra",
    error: "",
  },
  city: {
    value: "Nashik",
    error: "",
  },
  pincode: {
    value: "422001",
    error: "",
  },
  companyLogo: {
    value: require("assets/img/brand/argon-react.png"),
    error: "",
  },
  supportingDocuments: {
    value: [
      {
        ID: 1,
        documentPath: "/sample-doc.pdf",
      },
      {
        ID: 2,
        documentPath: "/sample-doc.pdf",
      },
      {
        ID: 3,
        documentPath: "/sample-doc.pdf",
      },
      {
        ID: 4,
        documentPath: "/sample-doc.pdf",
      },
      {
        ID: 5,
        documentPath: "/sample-doc.pdf",
      },
    ],
    error: "",
  },

  accountStatus: {
    value: "ACTIVE",
    error: "",
  },
  createdOn: {
    value: "10-Dec-2024",
    error: "",
  },
};

function ChannelPartnerDetail() {
  const authData = JSON.parse(localStorage.getItem("p") || "{}");
  const role = authData?.role;
  const { notify } = useContext(NotificationContext);
  const { id } = useParams();
  const dispatch = useDispatch();
  const decodedId = id ? urlDecodedId(id) : null;
  const [data, setData] = useState(initialState);
  const navigate = useNavigate();
  const [pageNum, setPageNum] = useState(1);
  const [isDownloading, setIsDownloading] = useState(false);
  const [showImageModal, setShowImageModal] = useState(false);
  const [documentModal, setDocumentModal] = useState({
    isOpen: false,
    title: "",
    url: "",
  });
  const [alternative, setAlternative] = useState({
    isLoading: true,
    showLoaderOnClick: false,
    error: "",
    noRecords: false,
  });
  const [searchState, setSearchState] = useState({
    searchName: "",
    searchEmail: "",
    searchMobile: "",
    filterParams: {
      filters: JSON.stringify([
        {
          field: "ChannelPartnerID",
          condition: "eq",
          filterValues: [String(decodedId)],
        },
      ]),
    },
  });
  const [showAlternative, setShowAlternative] = useState({
    isLoading: true,
    error: "",
  });

  const traineeDataList = useSelector((state) => state.trainees.traineeList);

  const fetchChannelPartnerDetails = async (id) => {
    try {
      setShowAlternative({
        isLoading: true,
        error: "",
      });
      const res = await getChannelPartnerById(id);

      if (res?.code !== 200 || !res.data) {
        setShowAlternative({
          isLoading: false,
          error: res?.message || "Failed to load channel partner details.",
        });
        return;
      }

      const d = res.data;

      setData({
        organizationName: {
          value: d.organizationName || "-",
          error: "",
        },

        firstName: {
          value: d.userID?.firstName || "",
          error: "",
        },

        lastName: {
          value: d.userID?.lastName || "",
          error: "",
        },

        contactPersonName: {
          value:
            `${d.userID?.firstName || ""} ${d.userID?.lastName || ""}`.trim(),
          error: "",
        },

        email: {
          value: d.userID?.email || "-",
          error: "",
        },

        mobileNumber: {
          value: d.userID?.mobile || "-",
          error: "",
        },

        gstNumber: {
          value: d.gstNo || "-",
          error: "",
        },

        panNumber: {
          value: d.panNo || "-",
          error: "",
        },

        registeredAddressLine1: {
          value: d.lineOne || "-",
          error: "",
        },

        registeredAddressLine2: {
          value: d.lineTwo || "-",
          error: "",
        },

        landmark: {
          value: d.landmark || "-",
          error: "",
        },

        state: {
          value: d.city?.state?.name || "-",
          error: "",
        },

        city: {
          value: d.city?.name || "-",
          error: "",
        },

        pincode: {
          value: d.pincode || "-",
          error: "",
        },

        companyLogo: {
          value: d.companyLogoImageURL || null,
          error: "",
        },

        supportingDocuments: {
          value: d.userDocuments || [],
          error: "",
        },

        accountStatus: {
          value: d.userID?.status || "INACTIVE",
          error: "",
        },

        createdOn: {
          value: d.createdAt || "-",
          error: "",
        },
      });
      setShowAlternative({
        isLoading: false,
        error: "",
      });
    } catch (error) {
      setShowAlternative({
        isLoading: false,
        error: error?.message || "Failed to load channel partner details.",
      });
    }
  };

  useEffect(() => {
    if (!decodedId) return;

    fetchChannelPartnerDetails(decodedId);
  }, [decodedId]);

  useEffect(() => {
    if (traineeDataList?.code === 200) {
      setAlternative({
        isLoading: false,
        error: "",
        noRecords: (traineeDataList?.data?.trainee?.length || 0) === 0,
        showLoaderOnClick: false,
      });
    } else if (traineeDataList?.code || traineeDataList?.message) {
      setAlternative({
        isLoading: false,
        error:
          traineeDataList?.message ||
          "Failed to load trainees. Please try again.",
        noRecords: false,
        showLoaderOnClick: false,
      });
    }
  }, [traineeDataList]);

  useEffect(() => {
    if (!decodedId) return;

    getTraineeList(dispatch, pageNum, searchState.filterParams);

    return () => {
      dispatch({ type: traineeList, payload: {} });
    };
  }, [dispatch, pageNum, decodedId, searchState.filterParams]);

  const formattedTraineeList = traineeDataList?.data?.trainee?.map(
    (item, index) => {
      return {
        ...item,
        srNo:
          (pageNum - 1) *
            (traineeDataList?.data?.noOfRecordsPerPage ||
              DEFAULT_RECORDS_PER_PAGE) +
          index +
          1,
        fullName: item?.user?.fullName || "",
        email: item?.user?.email || "",
        mobileNo: item?.user?.mobile || "",
        qrCode: item?.qrCodePath || "-",
        // status: item?.user?.status || "-",  //we can show this if needed
        createdOn: item?.user?.createdOn || "-",
      };
    },
  );

  const openDocument = (url, title = "Document") => {
    setDocumentModal({
      isOpen: true,
      title,
      url,
    });
  };

  const closeDocument = () => {
    setDocumentModal({
      isOpen: false,
      title: "",
      url: "",
    });
  };

  const buildFilterParams = () => {
    const filterParams = [
      {
        field: "ChannelPartnerID",
        condition: "eq",
        filterValues: [String(decodedId)],
      },
    ];

    if (searchState.searchName.trim()) {
      filterParams.push({
        field: "FullName",
        condition: "match",
        filterValues: [searchState.searchName.trim()],
      });
    }

    if (searchState.searchEmail.trim()) {
      filterParams.push({
        field: "Email",
        condition: "like",
        filterValues: [searchState.searchEmail.trim()],
      });
    }

    if (searchState.searchMobile.trim()) {
      filterParams.push({
        field: "Mobile",
        condition: "like",
        filterValues: [searchState.searchMobile.trim()],
      });
    }

    return {
      filters: JSON.stringify(filterParams),
    };
  };

  const clearSearch = () => {
    setAlternative((prev) => ({
      ...prev,
      isLoading: true,
    }));
    setSearchState({
      searchName: "",
      searchEmail: "",
      searchMobile: "",
      filterParams: {
        filters: JSON.stringify([
          {
            field: "ChannelPartnerID",
            condition: "eq",
            filterValues: [String(decodedId)],
          },
        ]),
      },
    });

    if (pageNum !== 1) {
      setPageNum(1);
    }
  };

  const handleSearch = () => {
    if (
      !searchState.searchName.trim() &&
      !searchState.searchEmail.trim() &&
      !searchState.searchMobile.trim()
    ) {
      return;
    }

    const newFilterParams = buildFilterParams();

    if (
      JSON.stringify(searchState.filterParams) !==
      JSON.stringify(newFilterParams)
    ) {
      setAlternative((prev) => ({
        ...prev,
        isLoading: true,
        showLoaderOnClick: true,
      }));
      setSearchState((prev) => ({
        ...prev,
        filterParams: newFilterParams,
      }));

      if (pageNum !== 1) {
        setPageNum(1);
      }
    }
  };

  const handleKeyDown = (e) => {
    if (e.key === "Enter") {
      e.preventDefault();
      handleSearch();
    }
  };

  const isFilterApplied =
    JSON.stringify(searchState.filterParams) !==
    JSON.stringify({
      filters: JSON.stringify([
        {
          field: "ChannelPartnerID",
          condition: "eq",
          filterValues: [String(decodedId)],
        },
      ]),
    });

  const downloadQR = async (trainee) => {
    setIsDownloading(true);
    try {
      const res = await downloadTraineeQRCode(trainee.ID);
      if (res.status === 200 && res.data) {
        const fileName =
          res.headers["content-disposition"]?.match(/filename="(.+?)"/)?.[1] ||
          "qr-code.png";

        const url = URL.createObjectURL(res.data);

        const a = document.createElement("a");
        a.href = url;
        a.download = fileName;
        a.click();
        URL.revokeObjectURL(url);
      } else if (res.code === 404) {
        notify(
          "danger",
          "The QR code for this trainee was not found. Please regenerate it.",
        );
      } else {
        notify(
          "danger",
          res?.message || "Failed to download QR code. Please try again.",
        );
      }
    } catch (error) {
      notify("danger", "Failed to download QR code. Please try again.");
    }
    setIsDownloading(false);
  };

  const column = [
    {
      Header: "Sr. No.",
      accessor: "srNo",
      centerAlign: true,
      minWidth: 80,
      maxWidth: 80,
    },
    {
      Header: "Trainee Name",
      accessor: "fullName",
      minWidth: 170,
      maxWidth: 170,
      Cell: ({ value }) => <span className="text-wrapper">{value || "-"}</span>,
    },
    {
      Header: "Email",
      accessor: "email",
      minWidth: 190,
      maxWidth: 190,
      Cell: ({ value }) => <span className="text-wrapper">{value || "-"}</span>,
    },
    {
      Header: "Mobile",
      accessor: "mobileNo",
      centerAlign: true,
      minWidth: 135,
      maxWidth: 135,
      Cell: ({ value }) => <span className="text-wrapper">{value || "-"}</span>,
    },
    // {
    //   Header: "Enrolled Courses",
    //   id: "courses",
    //   minWidth: 185,
    //   maxWidth: 200,
    //   disableSortBy: true,
    //   Cell: ({ row }) => {
    //     const courses = row.original.courses || [];
    //     const popoverId = `courses-${row.original.id}`;

    //     if (!courses.length) return <span className="text-muted">—</span>;

    //     return (
    //       <>
    //         <span
    //           id={popoverId}
    //           className="cursor d-inline-flex align-items-center text-primary"
    //         >
    //           {courses.length} Courses
    //           <i className="fa fa-info-circle ml-1 text-muted" />
    //         </span>

    //         <UncontrolledPopover
    //           target={popoverId}
    //           trigger="hover"
    //           placement="top"
    //         >
    //           <PopoverHeader>Enrolled Courses</PopoverHeader>

    //           <PopoverBody>
    //             <ul className="mb-0 pl-3">
    //               {courses.map((course, i) => (
    //                 <li key={i}>{course}</li>
    //               ))}
    //             </ul>
    //           </PopoverBody>
    //         </UncontrolledPopover>
    //       </>
    //     );
    //   },
    // },
    {
      Header: "QR Code",
      accessor: "qrCode",
      minWidth: 130,
      maxWidth: 130,
      disableSortBy: true,
      Cell: ({ row }) => {
        return (
          <Button
            className="btn-link p-0"
            size="sm"
            disabled={isDownloading}
            onClick={() => downloadQR(row.original)}
          >
            <i className="fa-solid fa-download mr-1" />
            Download
          </Button>
        );
      },
    },
    {
      Header: "Registered On",
      accessor: "createdOn",
      minWidth: 185,
      maxWidth: 200,
      Cell: ({ value }) => <span className="text-wrapper">{value || "-"}</span>,
    },
    {
      Header: "Actions",
      minWidth: 130,
      maxWidth: 130,
      disableSortBy: true,
      Cell: ({ row }) => {
        const traineeid = row.original.ID;
        const encodedTraineeID = traineeid ? urlEncodedId(traineeid) : null;

        return (
          <div className="actions-right d-flex justify-content-start align-items-center">
            {/* View */}
            <Button
              className="btn-link d-flex align-items-center p-0"
              id={`view${id}`}
              size="lg"
              onClick={(e) => {
                e.stopPropagation();
                navigate(
                  role === "SUPER_ADMIN"
                    ? `/super-admin/trainee/${encodedTraineeID}/details`
                    : `/admin/trainee/${encodedTraineeID}/details`,
                  {
                    state: {
                      channel: id,
                    },
                  },
                );
              }}
            >
              <i className="fa fa-eye mr-1 " />
            </Button>
            <UncontrolledTooltip delay={0} target={`view${id}`}>
              View
            </UncontrolledTooltip>
          </div>
        );
      },
    },
  ];

  return (
    <>
      <AdminHeader />

      <Container fluid className="mt--6">
        {/* <Row className="justify-content-center">
          <Col md="12">
            <Card>
              <CardHeader className="d-flex align-items-center justify-content-between">
                <div className="d-flex align-items-center">
                  <i
                    className="fa fa-chevron-left cursor mr-2"
                    onClick={() =>
                      navigate(
                        role === "SUPER_ADMIN"
                          ? "/super-admin/channel-partner"
                          : "/admin/channel-partner",
                      )
                    }
                  />
                  <h3 className="mb-0">Channel Partner Details</h3>
                </div>

                <div className="d-flex justify-content-end">
                  <Button
                    className="btn-deep-blue"
                    color="default"
                    onClick={() =>
                      navigate(
                        role === "SUPER_ADMIN"
                          ? `/super-admin/channel-partner/edit/${id}`
                          : `/admin/channel-partner/edit/${id}`,
                        {
                          state: { mode: "edit" },
                        },
                      )
                    }
                  >
                    <i className="fa-solid fa-pencil mr-1"></i>
                    Edit
                  </Button>
                </div>
              </CardHeader>
            </Card>
          </Col>
        </Row> */}

        <DetailsHeader
          onBack={() =>
            navigate(
              role === "SUPER_ADMIN"
                ? "/super-admin/channel-partner"
                : "/admin/channel-partner",
            )
          }
          backTooltip="Back to Channel Partners"
          showProfile={true}
          profileImage={data?.companyLogo?.value}
          //we can use this color as well: %23345187
          // Generate a fallback avatar as an inline SVG containing the contact person's initials (first letter of first and last name).
          //viewBox="0 0 100 100" creates a 100×100 virtual canvas.
          //<rect width="100" height="100" fill="%235e72e4"/> : Draws a rectangle covering the entire SVG.
          defaultImage={`data:image/svg+xml;utf8,<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 100 100"><rect width="100" height="100" fill="%235e72e4"/><text x="50%" y="50%" dominant-baseline="central" text-anchor="middle" fill="white" font-size="40" font-family="sans-serif" font-weight="bold">${`${(data?.firstName?.value || "").charAt(0)}${(data?.lastName?.value || "").charAt(0)}`.toUpperCase() || "?"}</text></svg>`}
          onProfileClick={
            data?.companyLogo?.value ? () => setShowImageModal(true) : undefined
          }
          title={data?.organizationName?.value}
          status={data?.accountStatus?.value}
          onEdit={() =>
            navigate(
              role === "SUPER_ADMIN"
                ? `/super-admin/channel-partner/edit/${id}`
                : `/admin/channel-partner/edit/${id}`,
              {
                state: { mode: "edit" },
              },
            )
          }
          editLabel="Edit"
          editTooltip="Edit Channel Partner"
          editIcon="fa fa-pencil"
          chips={[
            {
              id: "cpEmailChip",
              icon: "fas fa-envelope",
              value: data?.email?.value,
              tooltip: data?.email?.value,
            },
            {
              id: "cpPhoneChip",
              icon: "fas fa-phone",
              value: data?.mobileNumber?.value,
              tooltip: data?.mobileNumber?.value,
            },
            {
              id: "cpContactPersonChip",
              icon: "fas fa-user",
              name: "Contact Person",
              value:
                data?.contactPersonName?.value?.length > 80
                  ? `${data.contactPersonName.value.slice(0, 80)}...`
                  : data?.contactPersonName?.value,
              tooltip: `Contact Person: ${data?.contactPersonName?.value}`,
            },
          ]}
        />
        {showAlternative.isLoading ? (
          <Row className="mt-3">
            <Col md="12">
              <Card className="section-cards">
                <CardBody>
                  <div className="loaderContainer-sm py-6">
                    <i className="fa fa-spinner fa-spin fa-2xl loader" />
                  </div>
                </CardBody>
              </Card>
            </Col>
          </Row>
        ) : showAlternative.error ? (
          <Row className="mt-3">
            <Col md="12">
              <Card className="section-cards">
                <CardBody>
                  <div className="loaderContainer-sm error-style">
                    <div className="error-icon">
                      <i className="fa-solid fa-circle-exclamation" />
                    </div>
                    <span>{showAlternative.error}</span>
                  </div>
                </CardBody>
              </Card>
            </Col>
          </Row>
        ) : (
          <Row className=" mt-3">
            <Col md="12">
              <Row className="g-3">
                <Col md="6">
                  <Card className="section-cards h-100">
                    <CardHeader className="section-header">
                      <h4 className="mb-0 text-default section-title">
                        Basic Information
                      </h4>
                    </CardHeader>

                    <CardBody>
                      <Row>
                        <Col md="6">
                          <div className="mb-3 d-flex flex-column align-items-start ">
                            <Label className="small-label text-muted mb-1">
                              Organization Name
                            </Label>
                            <small className="small-text text-wrapper">
                              {data.organizationName.value}
                            </small>
                          </div>
                        </Col>

                        <Col md="6">
                          <div className="mb-3 d-flex flex-column align-items-start ">
                            <Label className="small-label text-muted mb-1">
                              Contact Person
                            </Label>
                            <small className="small-text text-wrapper">
                              {data.contactPersonName.value}
                            </small>
                          </div>
                        </Col>
                      </Row>
                      <Row className="mt--2">
                        <Col md="6">
                          <div className="mb-3 d-flex flex-column align-items-start mt-4">
                            <Label className=" small-label text-muted mb-1">
                              Email
                            </Label>
                            <small className="small-text text-wrapper">
                              {data.email.value}
                            </small>
                          </div>
                        </Col>

                        <Col md="6">
                          <div className="mb-3 d-flex flex-column align-items-start mt-4">
                            <Label className="small-label text-muted mb-1">
                              Mobile Number
                            </Label>
                            <small className="small-text">
                              {data.mobileNumber.value}
                            </small>
                          </div>
                        </Col>
                      </Row>
                    </CardBody>
                  </Card>
                </Col>

                <Col md="6">
                  <Card className="section-cards h-100">
                    <CardHeader className="section-header">
                      <h4 className="mb-0 text-default section-title">
                        Organization Details
                      </h4>
                    </CardHeader>

                    <CardBody>
                      {/* Row 1 */}
                      <Row className="mb-3">
                        <Col md="6">
                          <div className="mb-3 d-flex flex-column align-items-start ">
                            <Label className="small-label text-muted mb-1">
                              PAN Number
                            </Label>
                            <small className="small-text">
                              {data.panNumber.value}
                            </small>
                          </div>
                        </Col>

                        <Col md="6">
                          <div className="mb-3 d-flex flex-column align-items-start ">
                            <Label className="small-label text-muted mb-1">
                              GST Number
                            </Label>
                            <small className="small-text">
                              {data.gstNumber.value}
                            </small>
                          </div>
                        </Col>
                      </Row>

                      {/* Row 2 */}
                      <Row className="mb-3">
                        <Col md="6">
                          <div className="mb-3 d-flex flex-column align-items-start">
                            <Label className="small-label text-muted mb-1">
                              Address Line 1
                            </Label>
                            <small className="small-text text-wrapper">
                              {data.registeredAddressLine1.value}
                            </small>
                            {/* <small className="small-text">
                            {data.registeredAddressLine2.value}
                          </small> */}
                          </div>
                        </Col>
                        <Col md="6">
                          <div className="mb-3 d-flex flex-column align-items-start">
                            <Label className="small-label text-muted mb-1">
                              Address Line 2
                            </Label>
                            <small className="small-text text-wrapper">
                              {data.registeredAddressLine2.value}
                            </small>
                          </div>
                        </Col>
                      </Row>

                      {/* Row 3 */}
                      <Row>
                        <Col md="6">
                          <div className="mb-4-half d-flex flex-column align-items-start">
                            <Label className="small-label text-muted mb-1">
                              Landmark
                            </Label>
                            <small className="small-text text-wrapper">
                              {data.landmark.value}
                            </small>
                          </div>
                        </Col>
                        <Col md="6">
                          <div className="mb-4-half d-flex flex-column align-items-start ">
                            <Label className="small-label text-muted mb-1">
                              City
                            </Label>
                            <small className="small-text">
                              {data.city.value}
                            </small>
                          </div>
                        </Col>

                        <Col md="6">
                          <div className="mb-3 d-flex flex-column align-items-start ">
                            <Label className="small-label text-muted mb-1">
                              State
                            </Label>
                            <small className="small-text">
                              {data.state.value}
                            </small>
                          </div>
                        </Col>
                        <Col md="6">
                          <div className="mb-3 d-flex flex-column align-items-start ">
                            <Label className="small-label text-muted mb-1">
                              Pincode
                            </Label>
                            <small className="small-text">
                              {data.pincode.value}
                            </small>
                          </div>
                        </Col>
                      </Row>
                    </CardBody>
                  </Card>
                </Col>
              </Row>

              <Row className="mt-4">
                <Col md="12">
                  <Card className="section-cards">
                    <CardHeader className="section-header">
                      <h4 className="mb-0 text-default section-title">
                        Branding & Documents
                      </h4>
                    </CardHeader>

                    <CardBody>
                      <Row>
                        {/* Company Logo */}
                        <Col md="3" sm="12">
                          <div className="mb-3">
                            <Label className="small-label text-muted mb-2 d-block">
                              Company Logo
                            </Label>

                            {data.companyLogo.value ? (
                              <div className="doc-preview-container container-border">
                                <div className="doc-preview">
                                  <img
                                    src={data.companyLogo.value}
                                    alt="Company Logo"
                                    className="doc-image"
                                  />
                                </div>

                                <div className="doc-actions">
                                  <Button
                                    color="link"
                                    size="sm"
                                    className="doc-action-btn"
                                    onClick={() =>
                                      openDocument(
                                        data.companyLogo.value,
                                        "Company Logo",
                                      )
                                    }
                                  >
                                    <i className="fa fa-eye mr-1" />
                                    View
                                  </Button>
                                </div>
                              </div>
                            ) : (
                              <div className="doc-empty-state">
                                <i className="fa-regular fa-image doc-empty-icon" />
                                <p className="doc-empty-title">
                                  No logo uploaded
                                </p>
                              </div>
                            )}
                          </div>
                        </Col>

                        {/* Supporting Documents */}
                        <Col md="9" sm="12">
                          <div className="mb-3">
                            <Label className="small-label text-muted mb-2 d-block">
                              Supporting Documents
                            </Label>

                            {data.supportingDocuments.value?.length > 0 ? (
                              <div className="d-flex flex-wrap">
                                {data.supportingDocuments.value.map(
                                  (doc, index) => {
                                    const isPdf = doc.documentPath
                                      ?.toLowerCase()
                                      .endsWith(".pdf");

                                    return (
                                      <div
                                        key={index}
                                        className="doc-square mr-3 mb-3"
                                      >
                                        <div className="doc-preview">
                                          {isPdf ? (
                                            <div className="pdf-preview">
                                              <i className="fa fa-file-pdf text-danger fa-3x" />
                                              <div className="small mt-1">
                                                PDF Document
                                              </div>
                                            </div>
                                          ) : (
                                            <img
                                              src={doc.documentPath}
                                              alt="Document"
                                              className="doc-image"
                                            />
                                          )}
                                        </div>

                                        <div className="doc-actions">
                                          <Button
                                            color="link"
                                            size="sm"
                                            className="doc-action-btn"
                                            onClick={() =>
                                              openDocument(
                                                doc.documentPath,
                                                `Supporting Document ${index + 1}`,
                                              )
                                            }
                                          >
                                            <i className="fa fa-eye mr-1" />
                                            View
                                          </Button>
                                        </div>
                                      </div>
                                    );
                                  },
                                )}
                              </div>
                            ) : (
                              <div className="doc-empty-state">
                                <i className="fa-regular fa-folder-open doc-empty-icon" />
                                <p className="doc-empty-title">
                                  No documents available
                                </p>
                              </div>
                            )}
                          </div>
                        </Col>
                      </Row>
                    </CardBody>
                  </Card>
                </Col>
              </Row>

              <Row>
                <Col md="12">
                  <Card className="section-cards">
                    <CardHeader className="section-header">
                      <h4 className="mb-0 text-default section-title">
                        Trainees Added by Channel Partner
                      </h4>
                    </CardHeader>

                    <CardBody>
                      <div className="d-flex align-items-center justify-content-between mb-3 flex-wrap flex-column flex-md-row">
                        {/* Left side - Filter Inputs + Search */}
                        <div className="d-flex flex-wrap align-items-center filter-group">
                          <Input
                            type="text"
                            placeholder="Search by name"
                            value={searchState.searchName}
                            onChange={(e) =>
                              setSearchState((prev) => ({
                                ...prev,
                                searchName: e.target.value,
                              }))
                            }
                            className="mr-2 mb-2 filter-input-large"
                            onKeyDown={handleKeyDown}
                          />

                          <Input
                            type="text"
                            placeholder="Search by email"
                            value={searchState.searchEmail}
                            onChange={(e) =>
                              setSearchState((prev) => ({
                                ...prev,
                                searchEmail: e.target.value,
                              }))
                            }
                            className="mr-2 mb-2 filter-input-large"
                            onKeyDown={handleKeyDown}
                          />

                          <Input
                            type="text"
                            placeholder="Search by mobile no."
                            value={searchState.searchMobile}
                            onChange={(e) =>
                              setSearchState((prev) => ({
                                ...prev,
                                searchMobile: e.target.value,
                              }))
                            }
                            className="mr-2 mb-2 filter-input-large"
                            onKeyDown={handleKeyDown}
                          />

                          <Button
                            color="default"
                            onClick={handleSearch}
                            className={`d-flex align-items-center mb-2 filter-btn btn-deep-blue ${
                              alternative.showLoaderOnClick ? "search-btn" : ""
                            }`}
                          >
                            {alternative.showLoaderOnClick ? (
                              <i className="fa fa-spinner fa-spin" />
                            ) : (
                              <>
                                <i className="fa fa-search mr-1" />
                                Search
                              </>
                            )}
                          </Button>
                          {isFilterApplied && (
                            <Button
                              color="default"
                              className="d-flex align-items-center mb-2 filter-btn btn-deep-blue"
                              onClick={clearSearch}
                            >
                              <i className="fa fa-times mr-1" />
                              Clear
                            </Button>
                          )}
                        </div>
                      </div>
                      <div className="mt-2 mb-3 mx-1">
                        {traineeDataList?.data?.totalRecords > 0 ? (
                          <>
                            {isFilterApplied ? (
                              <span className="total-records">
                                Showing{" "}
                                {traineeDataList?.data?.totalFilteredRecords} of{" "}
                                {traineeDataList?.data?.totalRecords} Records
                              </span>
                            ) : (
                              <span className="total-records">
                                Total Records :{" "}
                                {traineeDataList?.data?.totalRecords}
                              </span>
                            )}
                          </>
                        ) : null}
                      </div>
                      {alternative.isLoading ? (
                        <div className="loaderContainer">
                          <i className="fa fa-spinner fa-spin fa-2xl loader" />
                        </div>
                      ) : alternative.error ? (
                        <div className="loaderContainer error-style">
                          <div className="error-icon">
                            <i className="fa-solid fa-circle-exclamation"></i>
                          </div>
                          <span>{alternative.error}</span>
                        </div>
                      ) : alternative.noRecords ? (
                        <div className="loaderContainer empty-style">
                          <div className="empty-icon">
                            <i className="fa-solid fa-circle-info"></i>
                          </div>
                          <span>No trainees found.</span>
                        </div>
                      ) : (
                        <div className="table-responsive">
                          <CommonTable
                            columns={column}
                            data={formattedTraineeList || []}
                            defaultPageSize={DEFAULT_RECORDS_PER_PAGE}
                            activePage={pageNum}
                            setPageNum={setPageNum}
                            totalPages={Math.ceil(
                              traineeDataList?.data?.totalFilteredRecords /
                                traineeDataList?.data?.noOfRecordsPerPage ||
                                DEFAULT_RECORDS_PER_PAGE,
                            )}
                            showPaginationBottom={true}
                          />
                        </div>
                      )}
                    </CardBody>
                  </Card>
                </Col>
              </Row>
            </Col>
          </Row>
        )}
      </Container>
      {showImageModal && (
        <div
          className="image-modal-overlay"
          onClick={() => setShowImageModal(false)}
        >
          <div className="image-modal-content">
            <img
              src={
                data?.companyLogo?.value ||
                require("assets/img/brand/argon-react.png")
              }
              alt="profile-large"
            />
          </div>
        </div>
      )}
      <CommonModal
        isOpen={documentModal.isOpen}
        toggle={closeDocument}
        title={documentModal.title}
        size="xl"
        height="80vh"
      >
        {documentModal.url &&
          (documentModal.url.toLowerCase().endsWith(".pdf") ? (
            <iframe
              src={documentModal.url}
              title={documentModal.title}
              width="100%"
              height="100%"
              className="document-preview-iframe"
            />
          ) : (
            <div className="text-center">
              <img
                src={documentModal.url}
                alt={documentModal.title}
                className="img-fluid document-preview-img modal-preview-media"
              />
            </div>
          ))}
      </CommonModal>
    </>
  );
}

export default ChannelPartnerDetail;
